import $ from 'jquery';

$(function () {
	$('.caret').on('click', function (e) {
		if (e.target.tagName.toUpperCase() === 'A') {
			// Do not expand the tree when the link to /search is clicked
			return;
		}
		$(this).parent().children('.nested').toggleClass('active');
		$(this).toggleClass('caret-down');
	});

	var expanded = false;
	$('#expand-all').on('click', function () {
		var carets = $('.caret');
		if (!expanded) {
			carets.parent().children('.nested').addClass('active');
			carets.addClass('caret-down');
			expanded = true;
			$(this).text('Sbalit vše');
			return;
		}

		carets.parent().children('.nested').removeClass('active');
		carets.removeClass('caret-down');
		$(this).text('Rozbalit vše');
		expanded = false;
	});
});
